import { createAction } from "@reduxjs/toolkit";

const actionTypes = {
	setRoles : createAction("setRoles"),
}
export default actionTypes
